import { render, staticRenderFns } from "./SelectBatch.vue?vue&type=template&id=ccfa372a&"
import script from "./SelectBatch.vue?vue&type=script&lang=js&"
export * from "./SelectBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports